import { Item } from '@react-stately/collections'
import { Selection } from '@react-types/shared'
import { ListSelect, ListSelectProps } from 'components/ListSelect/ListSelect'
import { Tone } from 'components/VoiceAndTonesSelect/Types'

interface Props extends Pick<ListSelectProps, 'selectionMode' | 'limit'> {
  onChange: (tones: Array<Tone>) => void
  selectedTones: Array<Tone>
  inline?: boolean
}

export const ToneSelect = ({ onChange, selectedTones, limit = 3 }: Props) => {
  const tones = Object.values(Tone)
  const handleChange = (selection: Selection) => {
    if (!(selection instanceof Set)) return

    onChange([...selection] as Tone[])
  }

  return (
    <ListSelect limit={limit} selectedKeys={selectedTones} selectionMode="multiple" onSelectionChange={handleChange}>
      {tones.map((tone) => (
        <Item key={tone}>{tone}</Item>
      ))}
    </ListSelect>
  )
}
